import { SkillType, SkillCategoryType } from ".";
import {
  Box,
  Flex,
  Subheading,
} from "../../common/Styles";
import styled from "styled-components";

const SkillCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 1.25rem;
  min-width: 160px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-4px);
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(74, 127, 229, 0.5);
    box-shadow: 0 8px 24px rgba(74, 127, 229, 0.2);
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #4a7fe5, #7d9ced, #a7baf3);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover::before {
    opacity: 1;
  }
`;

const SkillName = styled.h3`
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 0.75rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const SkillIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4a7fe5;
  font-size: 1.25rem;
`;

const ExperienceBar = styled.div<{ value: number }>`
  width: 100%;
  height: 6px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
  overflow: hidden;
  position: relative;
  margin-top: 0.5rem;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: ${(props) => (props.value / 5) * 100}%;
    background: linear-gradient(90deg, #4a7fe5, #7d9ced);
    border-radius: 3px;
    transition: width 0.3s ease;
  }
`;

const ExperienceLabel = styled.span`
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.75rem;
  margin-top: 0.5rem;
  display: block;
`;

const CategoryContainer = styled.div`
  margin-bottom: 3rem;
`;

const CategoryTitle = styled(Subheading)`
  font-size: 1.75rem;
  margin-bottom: 1.5rem;
  text-transform: capitalize;
  background: linear-gradient(135deg, #4a7fe5, #7d9ced);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-decoration: none;
  font-weight: 700;
`;

const SkillsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 1rem;
  width: 100%;

  @media (min-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
`;

interface Props {
  category: SkillCategoryType;
  skills: SkillType[];
}
const Skill: React.FC<Props> = ({ category, skills }) => {
  return (
    <CategoryContainer>
      <CategoryTitle>{category}</CategoryTitle>
      <SkillsGrid>
        {(skills || []).map((skill) => {
          const IconComponent = skill.icon;
          return (
            <SkillCard key={skill.name}>
              <SkillName>
                <SkillIcon>
                  <IconComponent size={20} color="#4a7fe5" />
                </SkillIcon>
                {skill.name}
              </SkillName>
              <ExperienceBar value={skill.experience} />
              <ExperienceLabel>
                {skill.experience} {skill.experience === 1 ? "year" : "years"} experience
              </ExperienceLabel>
            </SkillCard>
          );
        })}
      </SkillsGrid>
    </CategoryContainer>
  );
};

export default Skill;
